/**
 * Krokem — Home V2 (tema Savor).
 * 1) Parallax suave por puntero en el hero (rAF, sin listeners de scroll).
 * 2) Carrusel de best sellers con flechas "<  n/N  >".
 * Todo respeta prefers-reduced-motion.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------------------------ */
  /* 1. Parallax del hero                                                */
  /* ------------------------------------------------------------------ */
  function initParallax() {
    var heroes = document.querySelectorAll('[data-krokem-parallax]');
    if (!heroes.length || reduced.matches) return;
    // Sin puntero fino (movil/tablet) no hay parallax que valga la pena.
    if (!window.matchMedia('(pointer: fine)').matches) return;

    heroes.forEach(function (hero) {
      if (hero.dataset.krokemParallaxReady === 'true') return;
      hero.dataset.krokemParallaxReady = 'true';

      var layers = hero.querySelectorAll('[data-parallax-depth]');
      if (!layers.length) return;

      var targetX = 0, targetY = 0, currentX = 0, currentY = 0, raf = null;

      function render() {
        // Interpolacion suave hacia el objetivo (lerp).
        currentX += (targetX - currentX) * 0.07;
        currentY += (targetY - currentY) * 0.07;

        layers.forEach(function (layer) {
          var depth = parseFloat(layer.dataset.parallaxDepth) || 0;
          layer.style.translate =
            (currentX * depth).toFixed(2) + 'px ' + (currentY * depth).toFixed(2) + 'px';
        });

        if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
          raf = window.requestAnimationFrame(render);
        } else {
          raf = null;
        }
      }

      function schedule() {
        if (raf === null) raf = window.requestAnimationFrame(render);
      }

      hero.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse') return;
        var rect = hero.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        // -1..1 respecto al centro del hero, escalado a px.
        targetX = ((event.clientX - rect.left) / rect.width - 0.5) * 2 * 18;
        targetY = ((event.clientY - rect.top) / rect.height - 0.5) * 2 * 14;
        schedule();
      }, { passive: true });

      hero.addEventListener('pointerleave', function () {
        targetX = 0;
        targetY = 0;
        schedule();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 2. Carrusel de best sellers                                         */
  /* ------------------------------------------------------------------ */
  /*
    Paginacion por "vistas" de N cards, como el diseno ("2/4"), no por card
    suelta. En movil el CSS pasa a scroll-snap nativo y el track no se
    transforma, asi que el componente se apaga solo.
  */
  if (!window.customElements.get('krokem-carousel')) {
    window.customElements.define('krokem-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');
        this.countEl = this.querySelector('[data-carousel-count]');
        if (!this.track) return;

        this.page = 0;
        this.slides = Array.prototype.slice.call(this.track.children);

        this.onResize = this.update.bind(this);
        window.addEventListener('resize', this.onResize, { passive: true });

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.go.bind(this, -1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.go.bind(this, 1));

        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      // Cuantas cards caben por vista, leido del CSS real (no hardcodeado),
      // para que coincida con los breakpoints de la hoja de estilos.
      perView() {
        if (!this.slides.length) return 1;
        var slideW = this.slides[0].getBoundingClientRect().width;
        if (!slideW) return 1;
        var viewport = this.querySelector('[data-carousel-viewport]');
        var viewW = viewport ? viewport.getBoundingClientRect().width : 0;
        return Math.max(1, Math.round(viewW / slideW));
      }

      pages() {
        var per = this.perView();
        return Math.max(1, Math.ceil(this.slides.length / per));
      }

      go(dir) {
        var total = this.pages();
        this.page = Math.min(total - 1, Math.max(0, this.page + dir));
        this.update();
      }

      update() {
        // En movil manda el scroll-snap del CSS: no tocamos el transform.
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        var total = this.pages();
        if (this.page > total - 1) this.page = total - 1;

        if (mobile) {
          this.track.style.transform = '';
        } else {
          this.track.style.transform = 'translate3d(' + (-100 * this.page) + '%, 0, 0)';
        }

        if (this.countEl) this.countEl.textContent = (this.page + 1) + '/' + total;
        if (this.prevBtn) this.prevBtn.disabled = this.page === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.page >= total - 1;
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 3. Galaxy Stage: slider de slides del hero (crossfade)              */
  /* ------------------------------------------------------------------ */
  /*
    Con 1 solo slide el elemento no hace NADA: el Liquid no pinta ni
    flechas ni puntos ni data-multi, asi que se comporta como el hero fijo.
    Con 2+ hace crossfade con opacity/visibility, autoplay pausable,
    swipe por pointer events y teclado.
  */
  if (!window.customElements.get('krokem-stage')) {
    window.customElements.define('krokem-stage', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-stage-slide]'));
        // Un solo slide (o ninguno): hero estatico, nada que inicializar.
        if (this.dataset.multi !== 'true' || this.slides.length < 2) return;

        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-stage-dot]'));
        this.prevBtn = this.querySelector('[data-stage-prev]');
        this.nextBtn = this.querySelector('[data-stage-next]');
        this.countEl = this.querySelector('[data-stage-count]');
        this.index = 0;
        this.timer = null;
        this.paused = false;

        this.delay = parseInt(this.dataset.autoplay, 10) || 0;
        // Reduced motion: nunca autoplay (los controles siguen funcionando).
        if (reduced.matches) this.delay = 0;

        this._onPrev = this.go.bind(this, -1);
        this._onNext = this.go.bind(this, 1);
        if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);

        this.dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            this.select(parseInt(dot.dataset.goto, 10) || 0);
            this.restart();
          }.bind(this));
        }, this);

        // Pausa al hover y al foco dentro del escenario.
        this._pause = this.pause.bind(this);
        this._resume = this.resume.bind(this);
        this.addEventListener('mouseenter', this._pause);
        this.addEventListener('mouseleave', this._resume);
        this.addEventListener('focusin', this._pause);
        this.addEventListener('focusout', this._resume);

        // Teclado: flechas izquierda/derecha.
        this.setAttribute('tabindex', '-1');
        this._onKey = function (event) {
          if (event.key === 'ArrowLeft') { this.go(-1); this.restart(); }
          else if (event.key === 'ArrowRight') { this.go(1); this.restart(); }
        }.bind(this);
        this.addEventListener('keydown', this._onKey);

        this.initSwipe();
        this.select(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      // Swipe en movil via pointer events (sin librerias).
      initSwipe() {
        var startX = 0, startY = 0, tracking = false;
        var viewport = this.querySelector('[data-stage-viewport]') || this;

        viewport.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse') return;
          tracking = true;
          startX = event.clientX;
          startY = event.clientY;
        }, { passive: true });

        viewport.addEventListener('pointerup', function (event) {
          if (!tracking) return;
          tracking = false;
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          // Solo cuenta si el gesto es claramente horizontal.
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
          this.go(dx < 0 ? 1 : -1);
          this.restart();
        }.bind(this), { passive: true });

        viewport.addEventListener('pointercancel', function () { tracking = false; }, { passive: true });
      }

      select(i) {
        var total = this.slides.length;
        this.index = ((i % total) + total) % total;

        this.slides.forEach(function (slide, n) {
          var active = n === this.index;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');

          // Los videos fuera de pantalla no deben seguir sonando/gastando.
          var video = slide.querySelector('video');
          if (video) {
            if (active) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
            else video.pause();
          }
        }, this);

        this.dots.forEach(function (dot, n) {
          dot.setAttribute('aria-selected', n === this.index ? 'true' : 'false');
        }, this);

        if (this.countEl) this.countEl.textContent = (this.index + 1) + '/' + total;
      }

      go(dir) { this.select(this.index + dir); }

      start() {
        if (!this.delay || this.paused) return;
        this.stop();
        this.timer = window.setInterval(function () { this.go(1); }.bind(this), this.delay);
      }

      stop() {
        if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
      }

      restart() { this.stop(); this.start(); }

      pause() { this.paused = true; this.stop(); }

      resume() {
        // Si el foco sigue dentro (focusout dispara antes de focusin), no reanudar.
        if (this.contains(document.activeElement) && document.activeElement !== this) return;
        if (this.matches(':hover')) return;
        this.paused = false;
        this.start();
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 4. Altura real del escenario -> --k-stage-real                      */
  /* ------------------------------------------------------------------ */
  /*
    La altura del Galaxy Stage la fija el slide 1 (cookie planet) con su
    tamano natural. El video vertical flotante necesita conocer ESA altura
    para escalarse a ella, asi que la medimos y la publicamos como variable
    CSS en el <krokem-stage>. Se re-mide en resize y cuando cargan las
    imagenes del hero (la galleta define el alto).
  */
  function initStageHeight() {
    var stages = document.querySelectorAll('krokem-stage');
    if (!stages.length) return;

    stages.forEach(function (stage) {
      var hero = stage.querySelector('.k-slide--cookie_planet');
      if (!hero) return;

      function measure() {
        // scrollHeight del slide del hero = su altura natural de contenido.
        var h = hero.scrollHeight;
        if (h > 0) stage.style.setProperty('--k-stage-real', h + 'px');
      }

      measure();

      // Las imagenes del hero cambian el alto al cargar.
      stage.querySelectorAll('.k-slide--cookie_planet img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', measure, { once: true });
      });

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(measure);
        ro.observe(hero);
      } else {
        window.addEventListener('resize', measure, { passive: true });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 5. Bleed superior del hero -> --k-hero-pad-top                      */
  /* ------------------------------------------------------------------ */
  /*
    Los banners full bleed deben llegar hasta el tope, por DETRAS del header
    transparente, pero sin taparle la barra de aviso.

    Savor sube la primera seccion con `margin-top: -(header-group-height)`, de
    modo que el wrapper .shopify-section arranca en y=0 (detras del aviso) y
    su padding superior deja la banda de galaxia visible entre el header y el
    banner. Lo que hay que recuperar es ese padding, MENOS el trozo que queda
    por encima del borde inferior del aviso (o el banner lo taparia).

    Se mide en vivo porque el margen negativo y el alto del header cambian por
    breakpoint y con el header sticky.
  */
  function initHeroBleed() {
    var heroes = document.querySelectorAll('.k-hero');
    if (!heroes.length) return;

    heroes.forEach(function (hero) {
      function measure() {
        var padTop = parseFloat(getComputedStyle(hero).paddingTop) || 0;
        var heroTop = hero.getBoundingClientRect().top;

        // Borde inferior de la barra de aviso (el header NO cuenta: es
        // transparente y el banner debe pasar por detras de el).
        var announceBottom = 0;
        var group = document.getElementById('header-group');
        if (group) {
          Array.prototype.forEach.call(group.children, function (el) {
            if (el.classList.contains('header-section')) return;
            var r = el.getBoundingClientRect();
            if (r.height > 0 && r.bottom > announceBottom) announceBottom = r.bottom;
          });
        }

        // Cuanto del padding queda tapado por el aviso.
        var hidden = Math.max(0, announceBottom - heroTop);
        var bleed = Math.max(0, padTop - hidden);

        hero.style.setProperty('--k-hero-pad-top', bleed.toFixed(2) + 'px');
      }

      measure();
      window.addEventListener('resize', measure, { passive: true });
      window.addEventListener('load', measure);
      // El header mide su alto despues del primer paint (header.js).
      window.setTimeout(measure, 300);
      window.setTimeout(measure, 1200);
    });
  }

  /* ------------------------------------------------------------------ */
  /* 6. Countdown de pre-lanzamiento                                     */
  /* ------------------------------------------------------------------ */
  /*
    Busca cada [data-krokem-countdown], parsea su fecha ISO 8601 y actualiza
    dias/horas/minutos/segundos cada segundo. Fecha vacia o invalida: se
    dejan los "--" que ya trae el markup. Al llegar a cero: todo en 00, se
    agrega is-complete al contenedor y se limpia el intervalo.
  */
  var krokemCountdownTimers = [];

  function clearKrokemCountdownTimers() {
    krokemCountdownTimers.forEach(function (id) { window.clearInterval(id); });
    krokemCountdownTimers = [];
  }

  function padCountdownUnit(value) {
    var n = Math.max(0, value);
    return n < 10 ? '0' + n : String(n);
  }

  /*
    Reloj tipo aeropuerto (split-flap). Cada digito es una tarjeta partida al
    medio: al cambiar, la mitad de arriba cae mostrando el numero nuevo.
    Con prefers-reduced-motion el numero cambia sin animacion.
  */
  var krokemReduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function buildCountdownFlap(digit) {
    var flap = document.createElement('span');
    flap.className = 'k-flap';
    flap.setAttribute('aria-hidden', 'true');
    ['top', 'bottom', 'flip-top', 'flip-bottom'].forEach(function (part) {
      var half = document.createElement('span');
      half.className = 'k-flap__half k-flap__' + part;
      half.textContent = digit;
      flap.appendChild(half);
    });
    flap.dataset.digit = digit;
    return flap;
  }

  function flipCountdownFlap(flap, next) {
    var prev = flap.dataset.digit;
    if (prev === next) return;
    flap.dataset.digit = next;

    var top = flap.querySelector('.k-flap__top');
    var bottom = flap.querySelector('.k-flap__bottom');
    var flipTop = flap.querySelector('.k-flap__flip-top');
    var flipBottom = flap.querySelector('.k-flap__flip-bottom');

    if (krokemReduceMotion.matches) {
      top.textContent = bottom.textContent = flipTop.textContent = flipBottom.textContent = next;
      return;
    }

    // Arriba ya muestra el nuevo; abajo conserva el viejo hasta que cae la paleta.
    top.textContent = next;
    flipTop.textContent = prev;
    flipBottom.textContent = next;
    flap.classList.remove('is-flipping');
    void flap.offsetWidth; // reinicia la animacion si el giro anterior no termino
    flap.classList.add('is-flipping');

    window.clearTimeout(flap._kFlapTimer);
    flap._kFlapTimer = window.setTimeout(function () {
      bottom.textContent = next;
      flipTop.textContent = next;
      flap.classList.remove('is-flipping');
    }, 520);
  }

  function setCountdownUnit(el, text) {
    if (!el) return;
    el.setAttribute('aria-label', text);
    var flaps = el.querySelectorAll('.k-flap');
    if (flaps.length !== text.length) {
      el.textContent = '';
      text.split('').forEach(function (digit) { el.appendChild(buildCountdownFlap(digit)); });
      return;
    }
    flaps.forEach(function (flap, i) { flipCountdownFlap(flap, text.charAt(i)); });
  }

  /*
    Sin fecha confirmada: numeros pixelados que van cambiando al azar. Cada
    digito se dibuja en un canvas diminuto y se escala sin suavizado.
  */
  var KROKEM_PIXEL_W = 5;
  var KROKEM_PIXEL_H = 10;

  function drawCountdownPixel(canvas, digit) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, KROKEM_PIXEL_W, KROKEM_PIXEL_H);
    ctx.fillStyle = '#1226aa';
    ctx.font = '500 11px "FuturaPTCondensedMedium", Impact, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(digit, KROKEM_PIXEL_W / 2, KROKEM_PIXEL_H / 2 + 1);
  }

  function initCountdownPixel(clock) {
    var canvases = [];
    clock.classList.add('is-unknown');
    clock.querySelectorAll('.k-count__value').forEach(function (el) {
      el.textContent = '';
      el.setAttribute('aria-label', 'Coming soon');
      for (var i = 0; i < 2; i++) {
        var flap = document.createElement('span');
        flap.className = 'k-flap k-flap--pixel';
        flap.setAttribute('aria-hidden', 'true');
        var canvas = document.createElement('canvas');
        canvas.width = KROKEM_PIXEL_W;
        canvas.height = KROKEM_PIXEL_H;
        canvas.className = 'k-flap__pixel';
        flap.appendChild(canvas);
        el.appendChild(flap);
        canvases.push(canvas);
      }
    });

    function shuffle(all) {
      canvases.forEach(function (canvas) {
        if (all || Math.random() < 0.45) {
          drawCountdownPixel(canvas, String(Math.floor(Math.random() * 10)));
        }
      });
    }

    shuffle(true);
    if (document.fonts && document.fonts.load) {
      document.fonts.load('500 11px "FuturaPTCondensedMedium"').then(function () { shuffle(true); });
    }
    if (krokemReduceMotion.matches) return;
    krokemCountdownTimers.push(window.setInterval(function () { shuffle(false); }, 700));
  }

  function initCountdown() {
    clearKrokemCountdownTimers();

    var clocks = document.querySelectorAll('[data-krokem-countdown]');
    if (!clocks.length) return;

    clocks.forEach(function (clock) {
      var raw = (clock.getAttribute('data-krokem-countdown') || '').trim();
      var daysEl = clock.querySelector('[data-countdown-days]');
      var hoursEl = clock.querySelector('[data-countdown-hours]');
      var minutesEl = clock.querySelector('[data-countdown-minutes]');
      var secondsEl = clock.querySelector('[data-countdown-seconds]');

      var target = raw ? new Date(raw).getTime() : NaN;
      if (isNaN(target)) {
        // Sin fecha o fecha invalida: numeros pixelados si la seccion lo pide;
        // si no, se dejan los "--" del markup.
        if (clock.hasAttribute('data-krokem-countdown-pixel')) initCountdownPixel(clock);
        return;
      }
      clock.classList.remove('is-unknown');

      // render() devuelve true cuando la cuenta ya llego a cero, para que
      // quien la llama decida si vale la pena crear un intervalo. Antes se
      // creaba SIEMPRE un setInterval (incluso con fecha ya pasada al
      // cargar), y encima el clearInterval de aqui adentro se ejecutaba con
      // timerId todavia sin asignar en esa primera llamada sincronica.
      function render() {
        var diff = target - Date.now();

        if (diff <= 0) {
          setCountdownUnit(daysEl, '00');
          setCountdownUnit(hoursEl, '00');
          setCountdownUnit(minutesEl, '00');
          setCountdownUnit(secondsEl, '00');
          clock.classList.add('is-complete');
          return true;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        // Los dias no llevan relleno mas alla de 2 digitos (no tiene sentido
        // forzar "007" para una fecha lejana); horas/min/seg siempre a 2.
        setCountdownUnit(daysEl, days < 10 ? padCountdownUnit(days) : String(days));
        setCountdownUnit(hoursEl, padCountdownUnit(hours));
        setCountdownUnit(minutesEl, padCountdownUnit(minutes));
        setCountdownUnit(secondsEl, padCountdownUnit(seconds));
        return false;
      }

      // Primera pintura sincronica. Si la fecha ya paso, se deja todo en
      // "00" + is-complete y NO se crea ningun intervalo.
      if (render()) return;

      var timerId = window.setInterval(function () {
        if (render()) {
          window.clearInterval(timerId);
          krokemCountdownTimers = krokemCountdownTimers.filter(function (id) {
            return id !== timerId;
          });
        }
      }, 1000);
      krokemCountdownTimers.push(timerId);
    });
  }

  function init() {
    initParallax();
    initStageHeight();
    initHeroBleed();
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas re-inyecta secciones: re-inicializamos.
  document.addEventListener('shopify:section:load', init);
})();
